/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".my-content[_ngcontent-%COMP%]{padding:1rem;overflow:auto;height:100%}.my-content[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]{padding-bottom:2rem}.my-content[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-weight:700;font-size:2rem}.my-content[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]   .let-us-know[_ngcontent-%COMP%]{font-size:1.6rem}"];
export { styles as styles };
